import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgSettingsRoomGroup({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path d="M15.91 8.94l-1.88 4.23c-.3.52-.85.83-1.44.83H3.17a.63.63 0 01-.54-.94l1.89-4.23c.3-.52.85-.83 1.44-.83h9.41c.49 0 .79.52.54.94zM5.96 7.17h7.54V5.92c0-.7-.56-1.25-1.25-1.25H8.08L6.42 3H3.25C2.56 3 2 3.56 2 4.25v8.24l1.8-4.08a2.5 2.5 0 012.16-1.24z" />
    </svg>
  );
}

SvgSettingsRoomGroup.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgSettingsRoomGroup.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgSettingsRoomGroup svgRef={ref} {...props} />
));
export default ForwardRef;
